import { Result, failure, success } from '../shared'
import { CRAProvider } from './cra.provider'
import {
  CRAServiceErrorCode,
  CRAFailure,
  CRARequestServerData,
  CRAStatusServerData,
  CRAProfileServerData,
  AddCRAClientServerData,
} from './cra.types'

export class CRAService {
  constructor(private provider: CRAProvider) {}

  public async get(
    pin: string,
    idDocNo: number,
    birthYear: number,
    subContractId: number,
  ): Promise<Result<CRARequestServerData, CRAFailure>> {
    try {
      const { data } = await this.provider.get(pin, idDocNo, birthYear, subContractId)
      return success(data)
    } catch (error) {
      return failure(CRAServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getStatus(id: number): Promise<Result<CRAStatusServerData, CRAFailure>> {
    try {
      const { data } = await this.provider.getStatus(id)
      return success(data)
    } catch (error) {
      return failure(CRAServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getData(id: number): Promise<Result<CRAProfileServerData, CRAFailure>> {
    try {
      const { data } = await this.provider.getData(id)
      return success(data)
    } catch (error) {
      return failure(CRAServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async printCRA(action: string): Promise<Result<unknown, CRAFailure>> {
    try {
      const { data } = await this.provider.printCRA(action)
      return success(data)
    } catch (error) {
      return failure(CRAServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async add(
    pin: string,
    requestId: number,
    requestHash: string,
    clientId: number,
    clientHash: string,
  ): Promise<Result<AddCRAClientServerData, CRAFailure>> {
    try {
      const { data } = await this.provider.add(pin, requestId, requestHash, clientId, clientHash)
      return success(data)
    } catch (error) {
      return failure(CRAServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
